module.exports = __webpack_public_path__ + "static/media/fashion_men_11.0ba8764b.png";